import React, { useState } from "react";
import { Colors } from "../../config/Constants";
import {
  Header,
  Container,
  RowWrapper,
  TextWrapper,
  ErrorMessage,
  ActionWrapper,
} from "../../pages/EntryAccess";
import { phoneNumberValidation } from "../../pages/EntryAccess/validation";
import Box from "../Box";
import Button from "../Button";
import Textfield from "../Textfield";

interface ReservationProps {
  postChangedData: any;
  disputeNumber: string;
  setDisputeNumber: any;
}

const DisputeNumber = ({
  postChangedData,
  disputeNumber,
  setDisputeNumber,
}: ReservationProps) => {
  const [disputeError, setDisputeError] = useState("");

  const handleDisputeNumber = () => {
    let isValid = phoneNumberValidation(disputeNumber, setDisputeError);
    if (isValid) {
      let data = {
        name: "Dispute intimation",
        phone: Number(disputeNumber),
        isActive: true,
      };
      postChangedData("disputenotify", data);
    }
  };
  return (
    <div>
      <Header>Dispute Notification Configuration</Header>
      <Box>
        <Container>
          <RowWrapper>
            <TextWrapper>
              <Textfield
                value={disputeNumber}
                placeholder="Enter mobile number"
                textColor={Colors.black}
                label="Dispute Notification config"
                variant="outlined"
                size="medium"
                onChange={(e) => {
                  setDisputeNumber(e.target.value);
                  setDisputeError("");
                }}
                error={disputeError ? true : false}
              />
              {disputeError && <ErrorMessage>{disputeError}</ErrorMessage>}
            </TextWrapper>
            <ActionWrapper>
              <div className="disputeWrapper">
                <Button
                  variant="filled"
                  label="Save"
                  onClick={handleDisputeNumber}
                  color={Colors.red}
                />
              </div>
            </ActionWrapper>
          </RowWrapper>
        </Container>
      </Box>
    </div>
  );
};

export default DisputeNumber;
